import { appState } from '../../store/appState.js';
import { fetchTransactions } from '../../api/transactions.js';
import { logoutUser, getUserProfile, updateUserPassword, updateUserEmail, verifyCurrentPassword } from '../../api/auth.js';
import { showToast } from '../../utils/toast.js';

export function initSettingsModals() {
    // Modal controls for change password
    const btnPwd = document.getElementById('btn-settings-change-password');
    const pwdModal = document.getElementById('change-password-modal');
    const btnClosePwd = document.getElementById('btn-close-pwd');
    const btnSubmitPwd = document.getElementById('btn-submit-pwd');
    
    // Modal controls for change email
    const btnEmail = document.getElementById('btn-settings-change-email');
    const emailModal = document.getElementById('change-email-modal');
    const btnCloseEmail = document.getElementById('btn-close-email');
    const btnSubmitEmail = document.getElementById('btn-submit-email');

    // Auth & Exports buttons
    const btnExport = document.getElementById('btn-settings-export-csv');
    const btnImport = document.getElementById('btn-settings-import-csv');
    const inputImport = document.getElementById('input-import-csv');
    const btnLogout = document.getElementById('btn-settings-logout');

    if(!btnPwd) return;

    // Open change password modal
    btnPwd.addEventListener('click', () => {
        document.getElementById('input-current-pwd').value = '';
        document.getElementById('input-new-pwd').value = '';
        document.getElementById('input-confirm-pwd').value = '';
        document.getElementById('pwd-error').classList.add('hidden');
        
        pwdModal.classList.remove('hidden');
        pwdModal.classList.add('flex');
    });

    // Close change password modal via button
    btnClosePwd.addEventListener('click', () => {
        pwdModal.classList.add('hidden');
        pwdModal.classList.remove('flex');    
    });

    // Close change password via background click is already handled globally in main.js
    
    // Submit password
    btnSubmitPwd.addEventListener('click', async () => {
        const curPwd = document.getElementById('input-current-pwd').value;
        const p1 = document.getElementById('input-new-pwd').value;
        const p2 = document.getElementById('input-confirm-pwd').value;
        const err = document.getElementById('pwd-error');

        if (!curPwd) {
            err.innerText = "Please enter your current password.";
            err.classList.remove('hidden');
            return;
        }

        if (p1.length < 6) {
            err.innerText = "New password must be at least 6 characters.";
            err.classList.remove('hidden');
            return;
        }

        if (p1 !== p2) {
            err.innerText = "New passwords do not match.";
            err.classList.remove('hidden');
            return;
        }

        btnSubmitPwd.innerText = 'Verifying...';
        btnSubmitPwd.disabled = true;

        const verifyRes = await verifyCurrentPassword(curPwd);
        if (!verifyRes.success) {
            err.innerText = verifyRes.message;
            err.classList.remove('hidden');
            btnSubmitPwd.innerText = 'Submit change';
            btnSubmitPwd.disabled = false;
            return;
        }

        btnSubmitPwd.innerText = 'Updating...';
        const res = await updateUserPassword(p1);
        
        btnSubmitPwd.innerText = 'Submit change';
        btnSubmitPwd.disabled = false;

        if (res.success) {
            showToast('Password updated successfully', 'success');
            pwdModal.classList.add('hidden');
            pwdModal.classList.remove('flex');  
        } else {
            err.innerText = res.message;
            err.classList.remove('hidden');
        }
    });

    // Open change email modal
    if (btnEmail) {
        btnEmail.addEventListener('click', () => {
            document.getElementById('input-new-email').value = '';
            document.getElementById('email-error').classList.add('hidden');
            document.getElementById('email-success').classList.add('hidden');
            
            emailModal.classList.remove('hidden');
            emailModal.classList.add('flex');
        });

        // Close change email modal via button
        btnCloseEmail.addEventListener('click', () => {
            emailModal.classList.add('hidden');
            emailModal.classList.remove('flex');    
        });

        // Submit email
        btnSubmitEmail.addEventListener('click', async () => {
            const e1 = document.getElementById('input-new-email').value;
            const err = document.getElementById('email-error');
            const succ = document.getElementById('email-success');

            err.classList.add('hidden');
            succ.classList.add('hidden');

            if (!e1 || !e1.includes('@')) {
                err.innerText = "Please enter a valid email address.";
                err.classList.remove('hidden');
                return;
            }

            btnSubmitEmail.innerText = 'Updating...';
            btnSubmitEmail.disabled = true;

            const res = await updateUserEmail(e1);
            
            btnSubmitEmail.innerText = 'Submit change';
            btnSubmitEmail.disabled = false;

            if (res.success) {
                succ.innerText = "Change requested! Please check BOTH your old and new email inboxes to confirm the change.";
                succ.classList.remove('hidden');
                // Don't close immediately so user can read message
            } else {
                err.innerText = res.message;
                err.classList.remove('hidden');
            }
        });
    }

    // Logout logic
    btnLogout.addEventListener('click', async () => {
        const confirmLogout = confirm('Are you sure you want to log out?');
        if (!confirmLogout) return;

        showToast('Logging out...', 'info');
        const success = await logoutUser();
        if (success) {
            window.location.reload(); // Reload hard UI completely to auth screen
        } else {
            showToast('Logout failed. Try again.', 'error');
        }
    });

    // Export CSV logic
    btnExport.addEventListener('click', async () => {
        if (!appState.currentTransactionsList || appState.currentTransactionsList.length === 0) {
            appState.currentTransactionsList = await fetchTransactions();
        }

        if (appState.currentTransactionsList.length === 0) {
            showToast('No transactions to export', 'info');
            return;
        }

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += "ID,Type,Date,Amount,Currency,BaseAmount,Wallet,TargetWallet,Category,Tag,Remark\n";

        appState.currentTransactionsList.forEach(t => {
            const row = [
                t.id,
                t.type,
                t.transaction_date,
                t.amount,
                t.currency || 'VND',
                t.base_amount || 0,
                t.wallets ? `"${t.wallets.name}"` : '',
                t.linked_txn_id ? 'Transfer Link' : '',
                (t.categories?.name || t.category_name) ? `"${t.categories?.name || t.category_name}"` : '',
                (t.tags?.name || t.tag_name) ? `"${t.tags?.name || t.tag_name}"` : '',
                `"${t.remark || ''}"`
            ].join(',');
            
            csvContent += row + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `mmt_export_${new Date().toISOString().slice(0,10)}.csv`);
        document.body.appendChild(link); // Required for FF
        
        link.click();
        document.body.removeChild(link);
        showToast('Export successful!', 'success');
    });

    // Import CSV logic
    if (btnImport && inputImport) {
        btnImport.addEventListener('click', () => {
            inputImport.click();
        });

        inputImport.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            showToast('Reading file...', 'info');
            const reader = new FileReader();
            reader.onload = async function(event) {
                const text = event.target.result;
                const lines = text.split('\\n');
                if (lines.length > 1) {
                    showToast(`Found ${lines.length - 1} records. Import logic requires matching DB IDs. Contact support for bulk restore.`, 'info');
                    // In a full implementation, you'd parse lines and match wallet names to IDs
                    // For now, tell user it's a backup file and needs manual DB execution or further mapping component.
                }
            };
            reader.readAsText(file);
            // Reset input
            inputImport.value = '';
        });
    }

}

export async function renderSettingsTab() {
    // Lấy profile thực tế
    const user = await getUserProfile();
    
    if (user && user.email) {
        document.getElementById('settings-user-email').innerText = user.email;
        // Lấy tên từ email cho gọn nếu không có metadata firstName lastname
        const nameFallback = user.email.split('@')[0];
        document.getElementById('settings-user-name').innerText = user.user_metadata?.full_name || nameFallback;
    }
}
